import { render, staticRenderFns } from "./anchor-margins.vue?vue&type=template&id=2ee44ea2"
import script from "./anchor-margins.vue?vue&type=script&lang=js"
export * from "./anchor-margins.vue?vue&type=script&lang=js"
import style0 from "./anchor-margins.vue?vue&type=style&index=0&id=2ee44ea2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports